import * as types from '../../../actions/types';

const initialState = {
  info: {}
};

export default function students (state = initialState, action) {
  switch (action.type) {
    case types.SET_DASHBOARD_DETAILS_STUDENTS:
      return action.payload

    default:
      return state;
  }
}
